// frontend/src/pages/dashboard/ProjectComponents/AuthenticatedImage.js
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Box, CircularProgress } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';

// ============ GLOBAL IMAGE CACHE (Session Level) ============
const imageBlobCache = new Map();

const AuthenticatedImage = ({ attachment, style, onError }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    if (attachment?.id && imageBlobCache.has(attachment.id)) {
      setImageUrl(imageBlobCache.get(attachment.id));
      setLoading(false);
      return;
    }
    
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && attachment?.id) {
          const fetchImage = async () => {
            
            if (imageBlobCache.has(attachment.id)) {
              setImageUrl(imageBlobCache.get(attachment.id));
              setLoading(false);
              return;
            }

            try {
              const token = localStorage.getItem('access_token');
              const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/attachments/${attachment.id}/download`,
                {
                  responseType: 'blob',
                  headers: { Authorization: `Bearer ${token}` }
                }
              );
              const url = window.URL.createObjectURL(new Blob([response.data]));
              
              
              imageBlobCache.set(attachment.id, url);
              
              setImageUrl(url);
              setLoading(false);
            } catch (err) {
              console.error('Failed to load image:', err);
              setError(true);
              setLoading(false);
              onError?.(err);
            }
          };
          fetchImage();
          observer.disconnect();
        }
      },
      { rootMargin: '100px' }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [attachment?.id]);

  if (loading) {
    return (
      <Box ref={imgRef} sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5' }}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (error || !imageUrl) {
    return (
      <Box ref={imgRef} sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5' }}>
        <AttachFileIcon color="action" />
      </Box>
    );
  }

  return (
    <img
      ref={imgRef}
      src={imageUrl}
      alt={attachment.original_name}
      style={style}
      loading="lazy"
      onError={(e) => {
        e.target.style.display = 'none';
        e.target.nextSibling.style.display = 'flex';
      }}
    />
  );
};

export default AuthenticatedImage;